
import Vue from "vue";
import { data, T } from "../App.vue";
import PlayerAvatarContainer from "../components/PlayerAvatarContainer.vue";

export default Vue.extend({
  name: "SelectAvatar",
  components: {
    PlayerAvatarContainer,
  },
  props: {
    selectedId: Number,
  },
  methods: {
    T(key: string): string {
      return T(key);
    },
    avatarName(id: number): string {
      return T("Avatar_" + id);
    },
    clickedAvatar(id: number): void {
      data.clickCount++;
      this.$emit("avatar-clicked", id);
    },
  },
});
